import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { sweetalert } from '../services/sweetalert';

@Component({
  selector: 'app-emandata-screen',
  templateUrl: './emandata-screen.component.html',
  styleUrls: ['./emandata-screen.component.css']
})
export class EmandataScreenComponent implements OnInit {

  responseData: any="";
  emandataList:any;
  agreementData:any;
  showData:boolean=false;
  arrayOfKeys: string[];
  loader: boolean = false;
  constructor(private httpClient: HttpClient,private alert: sweetalert) {
    
   }

  ngOnInit(): void {
    
  }
  submitData(){
    this.loader=true
    console.log("okk"+this.agreementData);
      if(this.agreementData!=undefined && this.agreementData!=null){
        try {
          var convertedData=JSON.parse(this.agreementData);
        } catch (error) {
          
        }
       
        if (Array.isArray(convertedData)) {
          var wrongInput = false;
          convertedData.forEach(function(item){
             if(typeof item !== 'string'){
              wrongInput = true;
             }
          })
          if(!wrongInput && convertedData.length > 0){
            this.httpClient
            .post(environment.baseUrl + '/tvsm/insertEmandata',this.agreementData)
            .toPromise().then((iteam:any) => {
              console.log("data"+iteam);
              this.responseData=JSON.parse(iteam.data);
              console.log("data"+this.responseData.STATUS_CODE);
              if(this.responseData.STATUS_CODE=='SR'){
                this.showData=true;
                this.emandataList=JSON.parse(this.responseData.MANDATE_DETAILS);
                this.arrayOfKeys=Object.keys(this.emandataList[0]);
                console.log("this.emandataList"+this.emandataList);
                this.loader=false;
              }
             
            });
          }
          else{
            this.alert.errorsweertalert("Wrong Input....!!!");
            this.loader=false;
          }
         
       } else{
        this.alert.errorsweertalert("Wrong Input....!!!");
        this.loader=false;
      }
       
      }
      else{
        this.alert.errorsweertalert("Please enter data.");
        this.loader=false;
      }
  }

  clearData() {
    this.agreementData=null;
    this.showData=false;
    }
    

}
